import('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs').then(_ref => {
  let {
      Swiper
  } = _ref;

  var swiper = new Swiper(".resultSlider", {
      slidesPerView: 1,
      pagination: {
        el: ".results-pagination",
        clickable: true,
      },
      loop: true,
      navigation: {
          nextEl: ".results-button-next",
          prevEl: ".results-button-prev",
      },
      grabCursor: true,
      autoHeight: true
  });
})

document.querySelectorAll('.tab-button').forEach(e=> {
  e.addEventListener('click', function(evt) {
      evt.preventDefault()

      const id = e.dataset.id

      document.querySelectorAll('.tab-item,.tab-button').forEach(tab=> {
          tab.classList.remove('active')
      })

      this.classList.add('active')
      document.getElementById(id)?.classList.add('active')
  })
})


// Create a ColorsSelector class that extends HTMLElement
class SidebarTabs extends HTMLElement {
  constructor() {
    super();
    this.buttonItems = document.querySelectorAll('.button--item');
    this.tabItems = document.querySelectorAll('.tab-item');
    this.tabWrapper = document.querySelector('.tabs-v-wrapper');
    this.tabButtons = document.querySelector('.tab-buttons-wrapper');

    this.moveTabs() 
    this.tabClick()
  }


  rearrangeTabItems() {
  
      if (window.innerWidth <= 999) {
          // Move each tab item below its corresponding tab button
          this.tabButtons.forEach((button, index) => {
              const tabItem = tabItems[index];
              if (tabItem) {
                  button.insertAdjacentElement('afterend', tabItem);
              }
          });
      } else {
          // Move tab items back to their default state
          this.tabItems.forEach(tabItem => {
              tabsContainer.appendChild(tabItem);
          });
      }
  }

  moveTabs() {
      if (window.innerWidth <= 999) {
        // Append each .tab-item after its corresponding .button--item
        this.buttonItems.forEach((buttonItem, index) => {
          const tabItem = this.tabItems[index];
          buttonItem.insertAdjacentElement('afterend', tabItem);
        });
      } else {
        // Move .tab-item back to the .tabs-v-wrapper
        this.tabItems.forEach(tabItem => {
          this.tabWrapper.appendChild(tabItem);
        });
      }
  }

  tabClick() {
      const _this = this
      _this.querySelectorAll('.tab-button').forEach(e=> {
          e.addEventListener('click', function(evt) {
              evt.preventDefault()
              const id = e.dataset.id

              _this.querySelectorAll('.tab-item,.tab-button').forEach(tab=> {
                  tab.classList.remove('active')
              })

              this.classList.add('active')
              _this.querySelector('#' + id)?.classList.add('active')

              if (window.innerWidth <= 999) {
                  // Check if an element with the target ID exists in the DOM
                  var targetElement = _this.querySelector('#' + id)

                  if (targetElement) {
                      // Define an offset (adjust this value as needed)
                      var offsetTop = 50; // Change this to your desired offset

                      // Scroll to the target element with the specified offset
                      window.scrollTo({
                          top: _this.offset(targetElement).top - 100,
                          behavior: 'smooth' // You can change this to 'auto' for an instant scroll
                      });
                  }
              }
          })
      })
  }

  offset(el) {
      var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }
}

// Register the custom element
customElements.define('sidebar-tabs', SidebarTabs);

window.addEventListener('resize', SidebarTabs.moveTabs);

class SubsWidget extends HTMLElement {
  constructor() {
    super();
    this.radios = this.querySelectorAll('.subs__group_input');
    this.inputId = this.querySelector('[name="id"]');
    this.sellingId = this.querySelector('[name="selling_plan"]');
    
    // If not found within the widget, look in the parent form
    if (!this.inputId || !this.sellingId) {
      const parentForm = this.closest('form');
      if (parentForm) {
        this.inputId = this.inputId || parentForm.querySelector('[name="id"]') || parentForm.querySelector('#dynamic-variant-id');
        this.sellingId = this.sellingId || parentForm.querySelector('[name="selling_plan"]') || parentForm.querySelector('#dynamic-selling-plan');
      }
    }
    
    // Additional debugging - check if we can find the fields by ID
    if (!this.inputId || !this.sellingId) {
      const dynamicVariantId = document.querySelector('#dynamic-variant-id');
      const dynamicSellingPlan = document.querySelector('#dynamic-selling-plan');
      
      if (dynamicVariantId) this.inputId = dynamicVariantId;
      if (dynamicSellingPlan) this.sellingId = dynamicSellingPlan;
    }

    // Function to try to find and set form fields
    const findFormFields = () => {
      if (!this.inputId || !this.sellingId) {
        const dynamicVariantId = document.querySelector('#dynamic-variant-id');
        const dynamicSellingPlan = document.querySelector('#dynamic-selling-plan');
        if (dynamicVariantId) this.inputId = dynamicVariantId;
        if (dynamicSellingPlan) this.sellingId = dynamicSellingPlan;
        
        // If we found both fields, initialize the radio selection
        if (this.inputId && this.sellingId) {
          this.selectedRadio = this.querySelector('.subs__group_input:checked');
          this.activeRadio(this.selectedRadio);
        }
      }
    };

    // Try immediately
    findFormFields();
    
    // Also try after a delay
    setTimeout(findFormFields, 100);
    
    // Watch for form fields to be added to the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              if (node.id === 'dynamic-variant-id' || node.id === 'dynamic-selling-plan' || 
                  node.querySelector && (node.querySelector('#dynamic-variant-id') || node.querySelector('#dynamic-selling-plan'))) {
                findFormFields();
              }
            }
          });
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    const _this = this

    this.radios.forEach(r=> {
      r.addEventListener('change', function() {
          _this.activeRadio(r)
      })
    })

  }

  activeRadio(r) {
      if (!r) return;
      
      // Remove any existing appstle widgets that might interfere
      const interval = setInterval(() => {
          const widget = this.querySelector('.appstle_sub_widget');
          if (widget !== null) {
              widget.remove();
              clearInterval(interval);
              this.querySelector('[data-native-pre-order-btn]')?.removeAttribute('style');
          }
      }, 100);

      if (r.checked) {
          // Update the variant ID
          if (this.inputId && r.dataset.id) {
              this.inputId.value = r.dataset.id;
          }
          
          // Update price display
          const salePriceEl = this.querySelector('sale-price');
          if (salePriceEl && r.dataset.price) {
              salePriceEl.textContent = r.dataset.price;
          }

          // Handle preorder/sold out state
          if (r.classList.contains('preorder-variant')){
              this.classList.add('soldout-product');
          } else {
              this.classList.remove('soldout-product');
          }

          // Update compare price display
          if (r.dataset.comparePrice) {
              const comparePriceEl = this.querySelector('compare-at-price');
              if (comparePriceEl) {
                  comparePriceEl.textContent = r.dataset.comparePrice;
                  comparePriceEl.removeAttribute('hidden');
              }
          } else {
              const comparePriceEl = this.querySelector('compare-at-price');
              if (comparePriceEl) {
                  comparePriceEl.setAttribute('hidden','');
              }
          }
      }

      // Handle selling plan selection - always update the selling plan field
      if (this.sellingId) {
          if (r.checked && r.dataset.subsId) {
              this.sellingId.value = r.dataset.subsId;
              
              // Hide square payment for subscriptions
              const squarePlacement = this.querySelector('square-placement');
              if (squarePlacement) {
                  squarePlacement.style.display = 'none';
              }
          } else {
              this.sellingId.value = '';
              
              // Show square payment for one-time purchases
              const squarePlacement = this.querySelector('square-placement');
              if (squarePlacement) {
                  squarePlacement.style.display = 'block';
              }
          }
      }
  }
}

customElements.define('subs-widget', SubsWidget);

// Simple fetch override to debug cart responses and fix subscription data
// Note: This should not interfere with PreProduct app or other third-party cart add handlers
const originalFetch = window.fetch;
window.fetch = function(...args) {
if (args[0] && args[0].includes && args[0].includes('/cart/add.js')) {
  
  // Skip if this is likely a PreProduct or other third-party app request
  // PreProduct and other apps often use JSON body, not FormData
  const isFormData = args[1]?.body instanceof FormData;
  const isJSON = args[1]?.body && typeof args[1].body === 'string';
  
  // Only process FormData requests (native theme form submissions)
  // Skip JSON requests which are likely from third-party apps like PreProduct
  if (isFormData) {
    // Fix subscription data before sending
    const subsWidget = document.querySelector('subs-widget');
    if (subsWidget) {
      const selectedRadio = subsWidget.querySelector('.subs__group_input:checked');
      if (selectedRadio && selectedRadio.dataset.subsId) {
        // Update the FormData
        args[1].body.set('id', selectedRadio.dataset.id);
        args[1].body.set('selling_plan', selectedRadio.dataset.subsId);
      }
    }
  }
  
  // Handle the response and set flag for cart redirect
  return originalFetch.apply(this, args).then(response => {
    // Clone the response so we can return it unchanged
    const clonedResponse = response.clone();
    
    console.log('EG Cart Fix: Cart add request completed, response ok:', response.ok);
    console.log('EG Cart Fix: Theme variables:', window.themeVariables?.settings);
    
    // Check if this will redirect to cart page
    if (response.ok && (window.themeVariables?.settings?.cartType === "page" || window.themeVariables?.settings?.pageType === "cart")) {
      console.log('EG Cart Fix: Setting redirect flag for cart page');
      sessionStorage.setItem('eg_cart_redirect', 'true');
    } else {
      console.log('EG Cart Fix: Not setting redirect flag - cart type:', window.themeVariables?.settings?.cartType, 'page type:', window.themeVariables?.settings?.pageType);
    }
    
    return clonedResponse;
  });
}
return originalFetch.apply(this, args);
};

// Add form submission listener to see what's being submitted and fix subscription data
// Only process native product forms, not PreProduct or other third-party forms
document.addEventListener('submit', function(e) {
if (e.target.action && e.target.action.includes('/cart/add')) {
  // Skip if this is a PreProduct form
  // PreProduct hides native buttons and uses its own, so if the submit button is hidden, PreProduct should handle it
  const submitButton = e.target.querySelector('button[type="submit"]');
  if (submitButton && (submitButton.style.display === 'none' || 
                       submitButton.style.cssText.includes('display: none') ||
                       submitButton.hasAttribute('data-native-pre-order-btn') && 
                       window.getComputedStyle(submitButton).display === 'none')) {
    console.log('EG Cart Fix: Skipping form submission - PreProduct button is hidden, PreProduct should handle this');
    return;
  }
  
  // Skip if this is a PreProduct form (they often have specific attributes)
  // Also skip if the form is already being handled by a third-party app
  if (e.target.closest('[data-preproduct]') || e.target.hasAttribute('data-preproduct-handled')) {
    return;
  }
  
  // Check if this is a subscription form and fix the data
  const subsWidget = e.target.querySelector('subs-widget');
  if (subsWidget) {
    const selectedRadio = subsWidget.querySelector('.subs__group_input:checked');
    if (selectedRadio && selectedRadio.dataset.subsId) {
      
      // Find and update the form fields
      const variantIdField = e.target.querySelector('#dynamic-variant-id') || e.target.querySelector('[name="id"]');
      const sellingPlanField = e.target.querySelector('#dynamic-selling-plan') || e.target.querySelector('[name="selling_plan"]');
      
      if (variantIdField) {
        variantIdField.value = selectedRadio.dataset.id;
      }
      
      if (sellingPlanField) {
        sellingPlanField.value = selectedRadio.dataset.subsId;
      }
    }
  }
}
});

// Fix for PreProduct preorder app - ensure product is added to cart before redirect
// This handles the case where PreProduct redirects to cart but product isn't added yet
(function() {
// Store variant ID when PreProduct button is clicked or form is submitted
function storePreorderVariantId(variantId, productId) {
  if (variantId) {
    console.log('PreProduct Fix: Storing variant ID for preorder:', variantId);
    sessionStorage.setItem('preorder_variant_id', variantId);
    sessionStorage.setItem('preorder_redirect_time', Date.now().toString());
    if (productId) {
      sessionStorage.setItem('preorder_product_id', productId);
    }
  }
}

// Helper function to find the preorder variant ID from a form
function findPreorderVariantId(form) {
  if (!form) return null;
  
  // First, check if there's a selected preorder variant in subscription widget
  const subsWidget = form.querySelector('subs-widget');
  if (subsWidget) {
    const preorderRadio = subsWidget.querySelector('.preorder-variant:checked');
    if (preorderRadio && preorderRadio.dataset.id) {
      return preorderRadio.dataset.id;
    }
    // Also check any preorder variant (not just checked)
    const preorderRadios = subsWidget.querySelectorAll('.preorder-variant');
    for (const radio of preorderRadios) {
      if (radio.dataset.id) {
        return radio.dataset.id;
      }
    }
  }
  
  // Check variant picker for preorder variants
  const variantPicker = form.querySelector('variant-picker');
  if (variantPicker) {
    // Try to get product JSON to find unavailable variants
    try {
      const productJson = document.querySelector('script[type="application/json"][data-product-json]');
      if (productJson) {
        const product = JSON.parse(productJson.textContent);
        if (product && product.variants) {
          // Find the first unavailable variant (preorder variant)
          const preorderVariant = product.variants.find(v => v.available === false);
          if (preorderVariant) {
            return preorderVariant.id.toString();
          }
        }
      }
    } catch (err) {
      console.log('PreProduct Fix: Error parsing product JSON:', err);
    }
  }
  
  // Check if current variant in form is a preorder variant
  const variantIdField = form.querySelector('#dynamic-variant-id') || form.querySelector('[name="id"]');
  if (variantIdField && variantIdField.value) {
    // Check if this variant is marked as preorder
    const variantOption = form.querySelector(`[value="${variantIdField.value}"]`);
    if (variantOption && variantOption.closest('.preorder-variant')) {
      return variantIdField.value;
    }
    
    // Also check product JSON to see if this variant is unavailable
    try {
      const productJson = document.querySelector('script[type="application/json"][data-product-json]');
      if (productJson) {
        const product = JSON.parse(productJson.textContent);
        if (product && product.variants) {
          const variant = product.variants.find(v => v.id.toString() === variantIdField.value.toString());
          if (variant && !variant.available) {
            return variantIdField.value;
          }
        }
      }
    } catch (err) {
      // Ignore errors
    }
  }
  
  return null;
}

// Helper function to get product ID from form
function getProductIdFromForm(form) {
  if (!form) return null;
  
  try {
    const productJson = document.querySelector('script[type="application/json"][data-product-json]');
    if (productJson) {
      const product = JSON.parse(productJson.textContent);
      return product?.id?.toString();
    }
  } catch (err) {
    // Ignore errors
  }
  
  return null;
}

// Helper function to check if a product is a preorder product
function isPreorderProduct(form) {
  if (!form) return false;
  
  // Check if form has buy-buttons with preorder template
  const buyButtons = form.querySelector('.buy-buttons');
  if (buyButtons) {
    const template = buyButtons.getAttribute('template');
    if (template && template.includes('pre-order')) {
      return true;
    }
  }
  
  // Check for preorder button attributes (PreProduct sets these on native buttons)
  const preorderBtn = form.querySelector('[data-native-pre-order-btn]');
  if (preorderBtn) {
    return true;
  }
  
  // Check if native buttons are hidden (PreProduct hides them and adds its own)
  const nativeSubmitBtn = form.querySelector('button[type="submit"]');
  if (nativeSubmitBtn) {
    const computedStyle = window.getComputedStyle(nativeSubmitBtn);
    if (computedStyle.display === 'none' && nativeSubmitBtn.hasAttribute('data-native-pre-order-btn')) {
      return true;
    }
  }
  
  // Check if PreProduct app block exists on the page
  if (document.querySelector('[data-preproduct]') || 
      document.querySelector('.preproduct') ||
      document.querySelector('[class*="preproduct"]') ||
      document.querySelector('[id*="preproduct"]')) {
    return true;
  }
  
  // Check for PreProduct metafield script (from main-product.liquid)
  // This script is added when product.metafields.preproduct.preorder is true
  const scripts = document.querySelectorAll('script');
  for (const script of scripts) {
    if (script.textContent && script.textContent.includes('preproduct') && 
        script.textContent.includes('preorder')) {
      return true;
    }
  }
  
  // Check if any button in the form has preorder-related text
  const buttons = form.querySelectorAll('button');
  for (const btn of buttons) {
    const btnText = btn.textContent.toLowerCase().trim();
    if (btnText.includes('pre-order') || btnText.includes('preorder')) {
      return true;
    }
  }
  
  return false;
}

// Listen for clicks on any button within a product form or PreProduct buttons
document.addEventListener('click', function(e) {
  // Find the closest form
  let form = e.target.closest('form[action*="/cart/add"]');
  let clickedBtn = e.target.closest('button');
  
  // Also check if clicking on a PreProduct button (might be outside form)
  if (!form && clickedBtn) {
    // PreProduct buttons might be in a different container
    form = clickedBtn.closest('product-form')?.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]');
  }
  
  if (!form && !clickedBtn) return;
  
  // Get variant ID from form - prioritize finding the PREORDER variant
  let variantId = null;
  
  // First, try to find the preorder variant specifically
  if (form) {
    variantId = findPreorderVariantId(form);
  }
  
  // If no preorder variant found, fall back to form field (might be preorder if product only has one variant)
  if (!variantId && form) {
    const variantIdField = form.querySelector('#dynamic-variant-id') || form.querySelector('[name="id"]');
    if (variantIdField && variantIdField.value) {
      variantId = variantIdField.value;
    }
  }
  
  // Fallback: try to get from button attributes
  if (!variantId && clickedBtn) {
    variantId = clickedBtn.dataset.startingVariant || 
                clickedBtn.getAttribute('data-starting-variant') ||
                clickedBtn.dataset.variantId ||
                clickedBtn.getAttribute('data-variant-id') ||
                clickedBtn.dataset.variantid ||
                clickedBtn.getAttribute('data-variantid');
  }
  
  // Last resort: check buy-buttons for variant info
  if (!variantId) {
    const buyButtons = form?.querySelector('.buy-buttons') || document.querySelector('.buy-buttons');
    if (buyButtons) {
      const preOrderBtn = buyButtons.querySelector('[data-native-pre-order-btn]');
      if (preOrderBtn) {
        variantId = preOrderBtn.dataset.startingVariant || 
                   preOrderBtn.getAttribute('data-starting-variant');
      }
    }
  }
  
  // Final fallback: check if we're on a product page and can get variant from product JSON
  // But prefer unavailable variants (preorder variants)
  if (!variantId && window.location.pathname.includes('/products/')) {
    try {
      const productJson = document.querySelector('script[type="application/json"][data-product-json]');
      if (productJson) {
        const product = JSON.parse(productJson.textContent);
        if (product && product.variants) {
          // First try to find an unavailable variant (preorder)
          const preorderVariant = product.variants.find(v => v.available === false);
          if (preorderVariant) {
            variantId = preorderVariant.id.toString();
          } else if (product.selected_or_first_available_variant) {
            variantId = product.selected_or_first_available_variant.id.toString();
          }
        }
      }
    } catch (err) {
      // Ignore JSON parse errors
    }
  }
  
  // Get product ID for later use
  const productId = form ? getProductIdFromForm(form) : null;
  
  // Only store if we found a variant ID and this looks like a preorder product
  // We check this to avoid interfering with normal add-to-cart flows
  if (variantId) {
    // Check if it's a preorder product
    // First check the form-based detection (covers menopause shake and products with preorder template)
    let isPreorder = form ? isPreorderProduct(form) : false;
    
    // If form check didn't find it, try additional checks (for products without template suffix)
    if (!isPreorder) {
      // Check if PreProduct app is active on the page (most reliable indicator)
      if (document.querySelector('[data-preproduct]') || 
          document.querySelector('.preproduct') ||
          document.querySelector('[class*="preproduct"]')) {
        isPreorder = true;
      }
      // Check if button has preorder text (PreProduct buttons often have this)
      else if (clickedBtn) {
        const btnText = clickedBtn.textContent.toLowerCase().trim();
        if (btnText.includes('pre-order') || btnText.includes('preorder')) {
          isPreorder = true;
        }
      }
      // Check if native buttons are hidden (PreProduct hides them)
      else if (form) {
        const nativeBtn = form.querySelector('button[type="submit"][data-native-pre-order-btn]');
        if (nativeBtn && window.getComputedStyle(nativeBtn).display === 'none') {
          isPreorder = true;
        }
      }
    }
    
    if (isPreorder) {
      storePreorderVariantId(variantId, productId);
    }
  }
}, true); // Use capture phase to catch before PreProduct handles it

// Also listen for form submissions as a fallback
document.addEventListener('submit', function(e) {
  if (e.target.action && e.target.action.includes('/cart/add')) {
    const form = e.target;
    
      // Get variant ID from form - prioritize preorder variant
      let variantId = findPreorderVariantId(form);
      
      // Fallback to form field if no preorder variant found
      if (!variantId) {
        const variantIdField = form.querySelector('#dynamic-variant-id') || form.querySelector('[name="id"]');
        if (variantIdField && variantIdField.value) {
          variantId = variantIdField.value;
        }
      }
      
      if (variantId) {
        // Check if it's a preorder product using the same logic as click handler
        let isPreorder = isPreorderProduct(form);
        
        // Additional checks if form-based detection didn't find it
        if (!isPreorder) {
          // Check if PreProduct app is active
          if (document.querySelector('[data-preproduct]') || 
              document.querySelector('.preproduct') ||
              document.querySelector('[class*="preproduct"]')) {
            isPreorder = true;
          }
          // Check if native buttons are hidden (PreProduct hides them)
          const nativeBtn = form.querySelector('button[type="submit"][data-native-pre-order-btn]');
          if (nativeBtn && window.getComputedStyle(nativeBtn).display === 'none') {
            isPreorder = true;
          }
        }
        
        if (isPreorder) {
          const productId = getProductIdFromForm(form);
          storePreorderVariantId(variantId, productId);
        }
      }
  }
}, true);
})();

// Fix for EG Auto Add to Cart app timing issue
// When landing on cart page, check if EG app needs time to process
// This ensures free gifts are shown immediately without requiring a manual page refresh
(function() {
console.log('EG Cart Fix: Script loaded, current path:', window.location.pathname);

// Only run on cart page, not when cart drawer is open
// This prevents interference with the cart drawer progress bar
if (window.location.pathname.includes('/cart')) {
  // Prevent infinite reload loops - check if we've already processed this page load
  const reloadFlag = sessionStorage.getItem('eg_cart_fix_processed');
  if (reloadFlag === 'true') {
    console.log('EG Cart Fix: Already processed this page load, skipping to prevent infinite loops');
    sessionStorage.removeItem('eg_cart_fix_processed');
    return;
  }
  
  console.log('EG Cart Fix: On cart page, checking cart state...');
  
  // Check if we need to add a preorder product that wasn't added - OPTIMIZED
  const preorderVariantId = sessionStorage.getItem('preorder_variant_id');
  const preorderRedirectTime = sessionStorage.getItem('preorder_redirect_time');
  const preorderProductId = sessionStorage.getItem('preorder_product_id');
  
  if (preorderVariantId && preorderRedirectTime) {
    const timeSinceRedirect = Date.now() - parseInt(preorderRedirectTime);
    // Only process if redirect happened within last 5 seconds
    if (timeSinceRedirect < 5000) {
      // Find cart section once to avoid multiple DOM queries
      const cartSection = document.querySelector('.shopify-section--main-cart') || 
                         document.querySelector('form.cart-page')?.closest('section');
      const sectionId = cartSection?.id?.replace('shopify-section-', '') || 'main-cart';
      
      // Show loading state for better UX
      const cartForm = document.querySelector('form.cart-page');
      if (cartForm) {
        cartForm.style.opacity = '0.7';
        cartForm.style.pointerEvents = 'none';
      }
      
      // Optimized: Use AbortController for timeout on slow connections
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2000); // 2 second timeout
      
      fetch('/cart.js', { signal: controller.signal })
        .then(response => {
          clearTimeout(timeoutId);
          if (!response.ok) throw new Error('Cart check failed');
          return response.json();
        })
        .then(cart => {
          clearTimeout(timeoutId);
          const variantInCart = cart.items && cart.items.some(item => 
            item.variant_id && item.variant_id.toString() === preorderVariantId.toString()
          );
          
          // Check if there's a regular variant of the same product that needs to be removed
          let regularVariantToRemove = null;
          if (preorderProductId && cart.items) {
            regularVariantToRemove = cart.items.find(item => 
              item.product_id && item.product_id.toString() === preorderProductId.toString() &&
              item.variant_id && item.variant_id.toString() !== preorderVariantId.toString()
            );
          }
          
          // If we found a regular variant, remove it first
          if (regularVariantToRemove && !variantInCart) {
            console.log('PreProduct Fix: Removing regular variant before adding preorder variant');
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: regularVariantToRemove.key || regularVariantToRemove.id,
                quantity: 0
              })
            })
            .then(() => {
              // After removing, add the preorder variant
              addPreorderVariantToCart(preorderVariantId, sectionId, cartSection, cartForm);
            })
            .catch(() => {
              // If removal fails, still try to add preorder variant
              addPreorderVariantToCart(preorderVariantId, sectionId, cartSection, cartForm);
            });
            return;
          }
          
          if (!variantInCart) {
            addPreorderVariantToCart(preorderVariantId, sectionId, cartSection, cartForm);
          } else {
            // Preorder variant is already in cart, restore UI
            if (cartForm) {
              cartForm.style.opacity = '1';
              cartForm.style.pointerEvents = '';
            }
            sessionStorage.removeItem('preorder_variant_id');
            sessionStorage.removeItem('preorder_redirect_time');
            sessionStorage.removeItem('preorder_product_id');
          }
        })
        .catch(error => {
          clearTimeout(timeoutId);
          if (cartForm) {
            cartForm.style.opacity = '1';
            cartForm.style.pointerEvents = '';
          }
          // On timeout or error, just add product (faster than retrying)
          if (error.name === 'AbortError' || error.message) {
            addPreorderVariantToCart(preorderVariantId, sectionId, cartSection, cartForm);
          } else {
            sessionStorage.removeItem('preorder_variant_id');
            sessionStorage.removeItem('preorder_redirect_time');
            sessionStorage.removeItem('preorder_product_id');
          }
        });
    } else {
      // Clear old stored data
      sessionStorage.removeItem('preorder_variant_id');
      sessionStorage.removeItem('preorder_redirect_time');
      sessionStorage.removeItem('preorder_product_id');
    }
  }
  
  // Helper function to add preorder variant to cart
  function addPreorderVariantToCart(preorderVariantId, sectionId, cartSection, cartForm) {
    if (!preorderVariantId) return;
    
    const addUrl = cartSection ? '/cart/add.js?sections=' + sectionId : '/cart/add.js';
    
    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: preorderVariantId,
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(data => {
      if (data.id || data.variant_id) {
        sessionStorage.removeItem('preorder_variant_id');
        sessionStorage.removeItem('preorder_redirect_time');
        sessionStorage.removeItem('preorder_product_id');
        
        // If we got sections in response, update DOM directly (faster than reload)
        if (data.sections && data.sections[sectionId] && cartSection) {
          requestAnimationFrame(() => {
            cartSection.innerHTML = data.sections[sectionId];
            if (cartForm) {
              cartForm.style.opacity = '1';
              cartForm.style.pointerEvents = '';
            }
            // Trigger cart events for other components (non-blocking)
            setTimeout(() => {
              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                    bubbles: true,
                    detail: { baseEvent: 'variant:add', cart: cart }
                  }));
                })
                .catch(() => {});
            }, 0);
          });
        } else {
          // Fallback to reload if no sections
          window.location.reload();
        }
      } else {
        if (cartForm) {
          cartForm.style.opacity = '1';
          cartForm.style.pointerEvents = '';
        }
        sessionStorage.removeItem('preorder_variant_id');
        sessionStorage.removeItem('preorder_redirect_time');
        sessionStorage.removeItem('preorder_product_id');
      }
    })
    .catch(error => {
      if (cartForm) {
        cartForm.style.opacity = '1';
        cartForm.style.pointerEvents = '';
      }
      sessionStorage.removeItem('preorder_variant_id');
      sessionStorage.removeItem('preorder_redirect_time');
      sessionStorage.removeItem('preorder_product_id');
      // On slow connections, reload is often faster than retrying
      window.location.reload();
    });
  }
  
  // Function to check if cart has discounts applied (meaning EG app is done)
  function hasDiscounts(cart) {
    // Check for line item discounts
    const hasLineItemDiscounts = cart.items && cart.items.some(item => 
      item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0
    );
    
    // Check for total discounts
    const hasTotalDiscount = cart.total_discount && cart.total_discount > 0;
    
    // Check for cart level discount applications
    const hasCartLevelDiscounts = cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;
    
    return hasLineItemDiscounts || hasTotalDiscount || hasCartLevelDiscounts;
  }
  
  // Function to count visible cart items on the page
  // Try multiple selectors to be compatible with different theme structures
  function countVisibleCartItems() {
    // Try common cart item selectors
    const selectors = [
      '.order-summary__body tr',
      '.cart-item',
      '.cart__line-item',
      '[data-cart-item]',
      'tbody tr[data-cart-item]'
    ];
    
    for (const selector of selectors) {
      const items = document.querySelectorAll(selector);
      if (items.length > 0) {
        return items.length;
      }
    }
    
    return 0;
  }
  
  // Get initial cart state from the API
  fetch('/cart.js')
    .then(response => response.json())
    .then(initialCart => {
      const initialItemCount = initialCart.item_count;
      const initialHasDiscounts = hasDiscounts(initialCart);
      
      console.log('EG Cart Fix: Initial cart state:', {
        itemCount: initialItemCount,
        hasDiscounts: initialHasDiscounts,
        items: initialCart.items?.map(item => ({
          id: item.id,
          title: item.title,
          price: item.price,
          final_price: item.final_price,
          line_level_discounts: item.line_level_discount_allocations?.length || 0
        }))
      });
      
      // Check if there's a mismatch between server-rendered cart and API cart
      const serverRenderedItems = countVisibleCartItems();
      const apiItemCount = initialItemCount;
      
      console.log('EG Cart Fix: Server-rendered items:', serverRenderedItems, 'API items:', apiItemCount);
      
      // If there's a mismatch between what's shown and what the API says, reload
      if (serverRenderedItems !== apiItemCount && apiItemCount > 0) {
        console.log('EG Cart Fix: Mismatch detected! Server shows', serverRenderedItems, 'items but API shows', apiItemCount, '. Reloading...');
        sessionStorage.setItem('eg_cart_fix_processed', 'true');
        window.location.reload();
        return;
      }
      
      // Only check for EG app processing when we have exactly 1 item and no discounts
      // This is the specific scenario: customer adds preorder item, EG app needs to add free gift
      // Don't trigger for carts with multiple items to prevent flashing/infinite loops
      if (initialItemCount === 1 && !initialHasDiscounts) {
        console.log('EG Cart Fix: Single item detected (preorder scenario). Waiting for EG app to process (may add free gifts)...');
        
        // Function to check cart and reload if fully processed
        function checkCartAndReload(attempt = 1, maxAttempts = 12) {
          setTimeout(function() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(updatedCart => {
                const currentHasDiscounts = hasDiscounts(updatedCart);
                const currentItemCount = updatedCart.item_count;
                
                console.log('EG Cart Fix: Cart check attempt', attempt, ':', {
                  itemCount: currentItemCount,
                  initialItemCount: initialItemCount,
                  hasDiscounts: currentHasDiscounts,
                  itemsChanged: currentItemCount !== initialItemCount,
                  items: updatedCart.items?.map(item => ({
                    id: item.id,
                    title: item.title,
                    price: item.price,
                    final_price: item.final_price,
                    line_level_discounts: item.line_level_discount_allocations?.length || 0
                  })),
                  cartLevelDiscounts: updatedCart.cart_level_discount_applications?.length || 0
                });
                
                // Check if cart has changed (more items added - free gifts, or discounts applied)
                if (currentItemCount > initialItemCount || currentHasDiscounts) {
                  console.log('EG Cart Fix: Cart changed! Items:', currentItemCount, 'vs', initialItemCount, 'Discounts:', currentHasDiscounts);
                  console.log('EG Cart Fix: Reloading to show updated cart with free gifts...');
                  sessionStorage.setItem('eg_cart_fix_processed', 'true');
                  window.location.reload();
                } else if (attempt < maxAttempts) {
                  // Keep checking - EG app might still be processing
                  checkCartAndReload(attempt + 1, maxAttempts);
                } else {
                  console.log('EG Cart Fix: No changes detected after', maxAttempts, 'attempts. Cart appears to be in final state.');
                }
              })
              .catch(error => {
                console.log('EG Cart Fix: Cart check error:', error);
                // Don't retry on error, just log it
              });
          }, 800); // Check every 800ms
        }
        
        // Start checking after a short delay to give EG app time to start processing
        setTimeout(() => {
          checkCartAndReload();
        }, 500);
      } else {
        console.log('EG Cart Fix: Cart appears to be in final state already (has discounts or multiple items detected). No processing needed.');
      }
    })
    .catch(error => {
      console.log('EG Cart Fix: Initial cart fetch error:', error);
    });
}
})();
